import checkout from "./form5";

const {
  formField5: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
  },
} = checkout;

const initialValues5 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [supportData.name]: false,
};

export default initialValues5;
